import ButtonLink from '@oneflare/flarekit/lib/components/ButtonLink';
import H2 from '@oneflare/flarekit/lib/components/H2';
import media from '@oneflare/flarekit/lib/libs/media';
import { styled } from 'styled-components';

export const CTAButtonLinkStyled = styled(ButtonLink)`
  width: 211px;
  margin: 0 auto;
  font-size: 16px;
  white-space: nowrap;
`;

// these stylings will be override by flarekit H2 styling for unknown reason.
// use &&& to generate more specific class on this component to aviod the styling be override
export const H2Styled = styled(H2)`
  &&& {
    font-family: ${({ theme }) => theme.font.secondaryBold};
    color: ${({ theme }) => theme.color.white};
    font-size: 22px;
    margin-bottom: 24px;
    padding: 0 24px;

    ${media.smUp`
      font-size: 24px;
      padding: 0;
    `}

    ${media.lgUp`
      font-size: 28px;
      margin-bottom: 32px;
    `}
  }
`;
